import { SkuDTO } from '@/types/api/sku';
import {
  BlogCardData,
  BrandCardData,
  CollectionCardData,
  SkuCardData,
} from '@/types/cards';
import { ReactKeySuffix } from '@/types/other';

function createKeyGenerators<T>(
  generator: (item: T | null, index: number, suffix: ReactKeySuffix) => string
) {
  return {
    desktop: (item: T | null, index: number) =>
      generator(item, index, 'desktop'),
    mobile: (item: T | null, index: number) => generator(item, index, 'mobile'),
  };
}
function createKeyGenerator<T>(
  prefix: string,
  keyExtractor: (item: T) => string
) {
  return (item: T | null, index: number, suffix: ReactKeySuffix) =>
    generateReactKey(item, prefix, index, suffix, keyExtractor);
}

function generateReactKey<T>(
  item: T | null,
  prefix: string,
  index: number,
  suffix: ReactKeySuffix,
  formatter: (item: NonNullable<T>) => string
): string {
  if (item) {
    return `${prefix}-${formatter(item)}-${index}-${suffix}`;
  }
  return `${prefix}-${index}-${suffix}`;
}

const keyGenerators = {
  sku: createKeyGenerator<SkuCardData | SkuDTO>(
    'SkuCard',
    (sku) => `${sku.slug}-${sku.name}-${sku.id}`
  ),
  collection: createKeyGenerator<CollectionCardData>(
    'CollectionsCarousel',
    (collection) => `${collection.slug}-${collection.autorName}`
  ),
  brand: createKeyGenerator<BrandCardData>(
    'BrandsCarousel',
    (brand) => `${brand.id}-${brand.name}-${brand.image}`
  ),
  blog: createKeyGenerator<BlogCardData>(
    'BlogsCarousel',
    (blog) => `${blog.blogId}-${blog.blogSlug}`
  ),
};

export const getReactKey = {
  skuCarousel: createKeyGenerators(keyGenerators.sku),
  collectionCarousel: createKeyGenerators(keyGenerators.collection),
  brandCarousel: createKeyGenerators(keyGenerators.brand),
  blogCarousel: createKeyGenerators(keyGenerators.blog),
};
